<template>
    <div>
        <Breadcrumb style="position: relative;margin:0;"></Breadcrumb>
        <div class="info-wrapper">
            <h2 class="title text-center">自訂導覽</h2>
            <div class="customize-filter-wrapper my-3 px-5">
                <div class="mb-2 d-flex align-items-center">
                    <div class="text">預計停留時間</div>
                    <select
                        class="form-control"
                        v-model="paras.stayDuration"
                        @change="pagination.currentPage = 1"
                    >
                        <option
                            :value="item.key"
                            v-for="item in mappings.StayDuration"
                            :key="item.key"
                            v-text="item.name"
                            >一個小時以上</option
                        >
                    </select>
                </div>
                <div class="d-flex align-items-center">
                    <div class="text">距離我的位置</div>
                    <select
                        class="form-control"
                        v-model="paras.distance"
                        @change="pagination.currentPage = 1"
                    >
                        <option
                            :value="value"
                            v-for="(value, label) in distanceMapping"
                            :key="value"
                            v-text="label"
                            >50m</option
                        >
                    </select>
                </div>
                <!-- <button class="btn btn-recommend">推薦行程安排</button> -->
            </div>
            <div class="text-danger text-center" v-show="!isGPS">
                請開啟定位功能
            </div>
            <ul v-show="isGPS">
                <li
                    v-for="(attraction, index) in attractionListPagination"
                    :key="attraction.id"
                >
                    <a
                        href=""
                        @click.prevent="goAttractionsDetail(attraction.id)"
                    >
                        <div
                            class="list-card"
                            :class="{
                                dotted:
                                    index !==
                                    attractionListPagination.length - 1,
                            }"
                        >
                            <div class="img-wrapper">
                                <vue-load-image>
                                    <img
                                        slot="image"
                                        :src="
                                            `${apiPhotoUrl}/ori/${attraction.photoId}`
                                        "
                                        :alt="attraction.name"
                                    />
                                    <img
                                        slot="preloader"
                                        src="@/assets/image-loader.gif" class="w-100"
                                    />
                                    <img
                                        slot="error"
                                        class="border d-block"
                                        src=""
                                        alt="not found"
                                    />
                                </vue-load-image>
                            </div>
                            <div class="card-body">
                                <div class="title" v-text="attraction.name">
                                    林之助紀念館
                                </div>
                                <div
                                    class="distance"
                                    v-show="attraction.distance"
                                >
                                    <img
                                        src="@/assets/self_ic_map.png"
                                        alt="距離"
                                    />{{ attraction.distance }}m
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <button
                class="btn btn-more w-100 my-3"
                v-show="!showMore && isGPS && this.attractionListFilter.length"
                @click="showMore = true"
            >
                查看更多推薦
            </button>
            <Pagination
                v-show="showMore"
                :page-total="
                    Math.ceil(
                        this.attractionListFilter.length /
                            this.pagination.pageSize,
                    )
                "
                :page-index="pagination.currentPage"
                @change-index="pagination.currentPage = $event"
            ></Pagination>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { mapGetters, mapState } from 'vuex';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            showMore: false,
            pagination: {
                pageSize: 5,
                currentPage: 1,
            },
            paras: {
                stayDuration: 0,
                distance: 50,
            },
            distanceMapping: {
                '50m': 50,
                '100m': 100,
                '200m': 200,
                '400m': 400,
                '600m以下': 600,
                '600m以上': 601,
            },
        };
    },
    computed: {
        ...mapState('dataList', ['mappings']),
        ...mapState('userData', {
            isGPS: (state) => state.currentPosition[0] && state.currentPosition[1],
        }),
        ...mapGetters('dataList', ['nearbyAttractionList']),
        attractionListFilter() {
            return this.nearbyAttractionList.filter((item) => {
                let expected = item.stayDuration === this.paras.stayDuration;
                if (this.paras.distance > 600) {
                    expected = expected && item.distance >= this.paras.distance;
                } else {
                    expected = expected && item.distance <= this.paras.distance;
                }
                return expected;
            });
        },
        attractionListPagination() {
            const nList = [];
            for (
                let i = 0;
                i < this.attractionListFilter.length / this.pagination.pageSize;
                // eslint-disable-next-line no-plusplus
                i++
            ) {
                nList.push(
                    this.attractionListFilter.slice(
                        i * this.pagination.pageSize,
                        (i + 1) * this.pagination.pageSize,
                    ),
                );
            }
            return nList[this.pagination.currentPage - 1];
        },
    },
    methods: {
        goAttractionsDetail(id) {
            this.$router.push(`/guide/attractions/${id}`);
        },
    },
    components: {
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
